import React from 'react';
import './PendingTimeSheets.css'; // Import the CSS file for styles

const PendingTimeSheets = () => {
    return (
        <div className="pending-time-sheets-container">
            <div className="content-section">
                {/* Header Section */}
                <h3 style={{ fontSize: "20px", fontWeight: "300", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
                    How to track pending timesheets?
                </h3>

                {/* Description about pending timesheets */}
                <p className="description">
                    This section displays timesheets that are currently in a pending state. When an employee submits a timesheet, it remains in this status until it is reviewed and approved by the approval manager or super admin. 
                    Reviewing pending timesheets promptly helps avoid delays and ensures smooth processing.
                </p>

                {/* Step Guide */}
                <h4 className="section-heading">Steps to Track Pending Timesheets:</h4>
                <ul className="step-guide">
                    <li><strong>Step 1:</strong> If you are logged into the dashboard, navigate to the "Pending Sheets" section.</li>
                    <li><strong>Step 2:</strong> Select the pending timesheets and identify employees who haven’t submitted their timesheets.</li>
                </ul>

                {/* Image Representation */}
                <img
                    className="placeholder-image image_gatnix_support"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737375592/Pending_sheets-1_hwm7li.png"
                    alt="Pending Timesheets"
                    style={{ width: "70%", height: "auto", maxWidth: "650px", margin: "20px 0" }} // Increased size
                />

                {/* Tip Section */}
                <h4 className="section-heading">Tip:</h4>
                <p className="tip-text">
                    Click on the "Pending Sheets" section to view and select the relevant timesheets for review.
                </p>

                {/* Note Section */}
                <h4 className="section-heading">Note:</h4>
                <ul className="note-points">
                    <li>If an employee has not submitted their timesheet, the system automatically sends reminders and warning emails.</li>
                </ul>
            </div>
        </div>
    );
};

export default PendingTimeSheets;
